import {
    TextField,
    Filter,
    TextInput,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { RaEditButton } from "shared/src/components/buttons/RaEditButton";
import { RaListView } from "shared/src/components/views/RaListView";
import { CountryField } from "../components/fields/Ra/CountryField";
import { AddressField } from "../components/fields/Ra/AddressField";

const ManufacturerListFilter = (props) => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <TextInput
                title={translate("equip.name")}
                label="equip.name"
                source="name"
                alwaysOn
            />
        </Filter>
    );
};

export const ManufacturerList = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaListView
            {...props}
            filters={<ManufacturerListFilter />}
            pagination={<DefaultPagination />}
            perPage={50}
            actions={<ToolbarWithHistory create={true} export={true} />}
        >
            <DatagridWithHistory bulkActionButtons={false}>
                <TextField
                    title={translate("equip.name")}
                    label="equip.name"
                    source="name"
                />
                <AddressField
                    label={translate("equip.address", { addressNumber: "" })}
                />
                <TextField
                    title={translate("equip.zip")}
                    label={translate("equip.zip")}
                    source="address.zip"
                />
                <TextField
                    title={translate("equip.city")}
                    label={translate("equip.city")}
                    source="address.city"
                />
                <CountryField label={translate("equip.country")} />
                <RaEditButton />
            </DatagridWithHistory>
        </RaListView>
    );
};
